import { render, staticRenderFns } from "./VehicleInventory.vue?vue&type=template&id=f4153468&scoped=true"
import script from "./VehicleInventory.vue?vue&type=script&lang=js"
export * from "./VehicleInventory.vue?vue&type=script&lang=js"
import style0 from "./VehicleInventory.vue?vue&type=style&index=0&id=f4153468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4153468",
  null
  
)

export default component.exports